import React from 'react';

const SectionImage2 = () => {
  return (
    <div className="section-divider" data-aos="fade-in">
      <img src="/mainimage.png" alt="C.H.I. Logistics fleet" />
      <div className="section-divider__overlay">
        <p className="section-divider__text">Join Our Growing Team</p>
        <p className="section-divider__sub">
          Competitive pay, flexible routes, and a company that has your back.
        </p>
      </div>
    </div>
  );
};

export default SectionImage2;
